import { combineReducers } from "redux";
import { RootState } from "./types";
import menuReducer from "../features/Menu/state/reducer";
import loaderReducer from "common/loaderReducer";
import dealersReducer from "../features/Dealers/state/reducer";
import securityReducer from "features/Security/state/reducer";
import OpenSettingsPanelReducer from "features/SettingsPanel/state/reducer";
import chatmeterReducer from "features/Home/Modals/ModalStartElite/state/reducer";
import AdvancedLm from "features/Dealers/AdvancedLm/state/reducer";
import Reviews from "features/Dealers/Reviews/state/reducer";

const rootReducer = combineReducers<RootState>({
    openSettingsPanelState: OpenSettingsPanelReducer,
    dealers: dealersReducer,
    menu: menuReducer,
    loader: loaderReducer,
    security: securityReducer,
    chatmeter: chatmeterReducer,
    advancedLm: AdvancedLm,
    reviews: Reviews
});

export default rootReducer;
